import { signIn } from './signIn'
import { forgotPassword } from './forgotPassword'
import { general } from './general'
import { forgotPasswordCode } from './forgotPasswordCode'
import { forgotPasswordChanged } from './forgotPasswordChanged'
import { navBar } from './navBar'
import { accountSettings } from './accountSettings'
import { requestAccess } from './requestAccess'
import { companySettings } from './companySettings'
import { companyProfile } from './companyProfile'
import { fieldForms } from './fieldForms'
import { formBuilder } from './formBuilder'
import { mobilePreview } from './mobilePreview'

export const i18nEn = () => {
  return {
    sign_in: signIn(),
    forgot_password: forgotPassword(),
    general: general(),
    forgot_password_code: forgotPasswordCode(),
    forgot_password_changed: forgotPasswordChanged(),
    nav_bar: navBar(),
    account_settings: accountSettings(),
    request_access: requestAccess(),
    company_settings: companySettings(),
    company_profile: companyProfile(),
    field_forms: fieldForms(),
    form_builder: formBuilder(),
    mobile_preview: mobilePreview()
  }
}
